import { createPortal } from 'react-dom';

type PageLoaderPortalProps = {
  children: React.ReactNode;
};

const PageLoaderPortal = ({ children }: PageLoaderPortalProps) => {
  const id = 'pageloader';
  const el = document.getElementById(id);
  if (!el) {
    throw new Error(`'#${id}' container element was not found`);
  }

  return createPortal(children, el, id);
};

PageLoaderPortal.displayName = 'PageLoaderPortal';
export { PageLoaderPortal };
